import React, { useState } from 'react';
import Footer from './footer';
import { submitContactRequest } from '../repository/sendrequestRepository'; 
//import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
//import logoImage from '../assets/logo.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    requestedBy: '', 
    message: ''
  });

  const [status, setStatus] = useState({
    loading: false,
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation: Name, Role, and Message are required. At least one of Phone or Email is required.
    if (!formData.name || (!formData.phone && !formData.email) || !formData.requestedBy || !formData.message) {
      setStatus({ 
        loading: false, 
        message: 'Please provide your Name, Role, Message, and at least an Email or Phone number.', 
        isError: true 
      });
      return;
    }

    setStatus({ loading: true, message: 'Sending...', isError: false });

    const response = await submitContactRequest(formData);

    if (response.success) {
      setStatus({ loading: false, message: 'Message sent successfully!', isError: false });
      setFormData({ name: '', phone: '', email: '', requestedBy: '', message: '' });
    } else {
      setStatus({ loading: false, message: response.message || 'Failed to send message.', isError: true });
    }
  };

  return (
    <footer className="contact-section" id="contact">
      <div className="container contact-container">
        <div className="contact-info">
          <div className="contact-header">
            {/*<img src={logoImage} alt="ISPKD Logo" className="logo-img" />*/}
            <div className="contact-header-text">
              <h3 className="contact-title">               </h3>
              <p className="contact-description">
                {/*We support patients, families, and providers with information and resources on polycystic kidney disease.*/}
              </p>
            </div>
          </div>

          <div className="contact-details">
            <div className="detail-item">
              <div className="">
                {/*<FaMapMarkerAlt className="contact-icon" />*/}
              </div>
              {/*<span>Medical Centre Drive<br/>Health Care District<br/>Mumbai, India</span>*/}
            </div>
            <div className="detail-item">
              <div className="">
                {/*<FaEnvelope className="contact-icon" />*/}
              </div>
              {/*<span>info@pkdfoundation.org</span>*/}
            </div>
            <div className="detail-item">
              <div className="">
                {/*<FaPhone className="contact-icon" />*/}
              </div>
              {/*<span>+91 9988877776</span>*/}
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <h3 className="form-title">Send us a Message</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="Name" 
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input 
                type="text" 
                id="phone" 
                name="phone" 
                placeholder="Phone Number" 
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Email" 
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <select 
                id="requestedBy" 
                name="requestedBy" 
                value={formData.requestedBy}
                onChange={handleChange}
              >
                <option value="" disabled>Select Role</option>
                <option value="Doctor(Health Care Professional)">Doctor(Health Care Professional)</option>
                <option value="Patient">Patient</option>
              </select>
            </div>

            <div className="form-group">
              <textarea 
                id="message" 
                name="message" 
                rows="5" 
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={status.loading}
            >
              {status.loading ? 'Sending...' : 'Contact us'}
            </button>
            
            {status.message && (
              <p style={{ marginTop: '10px', color: status.isError ? 'red' : '#3fc269', fontSize: '18px', fontWeight: '500' }}>
                {status.message}
              </p>
            )}
          </form>
        </div>
      </div>

      <Footer />
    </footer>
  );
};

export default Contact;